import type { Room, RoomCreate, RoomUpdate } from "@/types";
import { apiClient } from "./client";

export const roomService = {
  list: async (propertyId: string): Promise<Room[]> => {
    const { data } = await apiClient.get<Room[]>("/admin/rooms", {
      params: { property_id: propertyId },
    });
    return data;
  },

  get: async (id: string): Promise<Room> => {
    const { data } = await apiClient.get<Room>(`/admin/rooms/${id}`);
    return data;
  },

  create: async (body: RoomCreate): Promise<Room> => {
    const { data } = await apiClient.post<Room>("/admin/rooms", body);
    return data;
  },

  update: async (id: string, body: RoomUpdate): Promise<Room> => {
    const { data } = await apiClient.patch<Room>(`/admin/rooms/${id}`, body);
    return data;
  },

  remove: async (id: string): Promise<void> => {
    await apiClient.delete(`/admin/rooms/${id}`);
  },
};
